import React from 'react'
import { Box, Center, Loader, Stack } from '@mantine/core'
import { AppText } from '../common/ui'

interface Props {
  inverted?: boolean;
  content?: string;
}

export default function LoadingComponent ({ inverted = true, content = 'Loading...' }: Props) {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: inverted ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.8)',
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Center>
        <Stack align="center" spacing="sm">
          <Loader size="md" color={inverted ? 'white' : 'gray'} />
          {content && (
            <AppText size="sm" color={inverted ? 'white' : 'dimmed'}>
              {content}
            </AppText>
          )}
        </Stack>
      </Center>
    </Box>
  )
}
